import React from "react";

import { App, Button, Form, Input, InputNumber, Switch } from "antd";
import { useTranslation } from "react-i18next";

import { API_URL } from "../../shared/utils/Util";
import { fetchT } from "../../shared/utils/TypedUtil";
import { useNotification } from "../../shared/hooks";
import { CreateTableRequest, CreateTableResponse } from "../../types/api";

type RestaurantFeatureFlagFormProps = {
  restaurantId: string;
  onSuccess: () => void;
};

export const RestaurantFeatureFlagForm = (props: RestaurantFeatureFlagFormProps) => {
  const { notification } = App.useApp();
  const { notifyError } = useNotification();
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [form] = Form.useForm();

  const handleSave = (req: CreateTableRequest) => {
    setSaveLoading(true);

    fetchT<{}>(
      "POST",
      `${API_URL}/v1/r/${props.restaurantId}/feature_flags`,
      req,
      (result: CreateTableResponse) => {
        notification.success({
          message: t("success"),
          description: t("updated_feature_flag_successfully"),
        });
        form.resetFields();
        setSaveLoading(false);
        props.onSuccess();
      },
      (err: any) => {
        setSaveLoading(false);
        notifyError(t("failed_to_save_feature_flag"), err);
      }
    );
  };

  return (
    <Form
      form={form}
      initialValues={{
        flag_name: "",
        enabled: false,
      }}
      labelCol={{ span: 10 }}
      labelAlign="left"
      wrapperCol={{ span: 16 }}
      layout="horizontal"
      colon={false}
      onFinish={handleSave}
    >
      <Form.Item
        label={t("flag_name")}
        name="flag_name"
        rules={[
          {
            required: true,
            message: t("name_is_required"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t("enabled")}
        name="enabled"
        rules={[
          {
            required: true,
            message: t("enabled_is_required"),
          },
        ]}
        valuePropName="checked"
      >
        <Switch checkedChildren={t("yes")} unCheckedChildren={t("no")} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" block htmlType="submit" loading={saveLoading} disabled={saveLoading}>
          {t("save")}
        </Button>
      </Form.Item>
    </Form>
  );
};
